const TYPE = "ADMIN";

export default {
  path: "profile",
  // meta: { label: "Profile" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
        type: TYPE,
      },
      component: () => import("@/views/profile/profileDetails.vue"),
      alias: "profile",
      children: [
        {
          path: "profile-info",
          meta: {
            label: "Info",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/profile.vue"),
        },
        {
          path: "languageSettings",
          meta: {
            label: "Language settings",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/languageSettings.vue"),
        },
        {
          path: "currencySettings",
          meta: {
            label: "Currency Settings",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/currencySettings.vue"),
        },
        {
          path: "deviceBinding",
          meta: {
            label: "Device Binding",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/deviceBinding.vue"),
        },
        {
          path: "paymentConfig",
          meta: {
            label: "Payment Config",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/paymentConfig.vue"),
        },
        {
          path: "loginSecurity",
          meta: {
            label: "Login Security",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/loginSecurity.vue"),
        },
        {
          path: "b2bProvider",
          meta: {
            label: "B2B Provider",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/b2bProvider.vue"),
        },
        {
          path: "notificationSettings",
          meta: {
            label: "Notification Settings",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/notification.vue"),
        },
        {
          path: "extendedAttributes",
          meta: {
            label: "Extended Attributes",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/extendedAttributes.vue"),
        },
        {
          path: "deleveryPartners",
          meta: {
            label: "Delevery Partners",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/deleveryList.vue"),
        },
        {
          path: "kycPreferences",
          meta: {
            label: "KYC Preferences",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/kycPreferences.vue"),
        },
        {
          path: "webhook",
          meta: {
            label: "Webhook Integration",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/webhook.vue"),
        },
        {
          path: "buildGeneration",
          meta: {
            label: "Build Generation",
            requiresAuth: true,
            type: TYPE,
          },
          component: () => import("@/views/profile/buildGeneration.vue"),
        },
      ],
    },
  ],
};
